import { Trans } from 'react-i18next';
import { Link } from '@/UI/Link/Link';
import { Typography } from '@/UI/AppTypography/AppTypography';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';

const LINK_PROPS = {
  component: 'a',
  target: '_blank',
  rel: 'noopener noreferrer',
  color: 'inherit',
  sx: {
    textDecorationColor: 'inherit',
    '&:hover': {
      textDecoration: 'none',
    },
  },
};

type UnverifiedModelDisclaimerProps = {
  termsUrl: string;
  privacyUrl: string;
  additionalTermsLink?: string;
};

export const UnverifiedModelDisclaimer = ({
  termsUrl,
  privacyUrl,
  additionalTermsLink,
}: UnverifiedModelDisclaimerProps) => (
  <Typography variant="body-xs-rg" color={color.White64_T}>
    <Trans
      i18nKey={
        additionalTermsLink
          ? I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS
          : I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.UNVERIFIED_DISCLAIMER
      }
      components={{
        ...(additionalTermsLink && {
          additionalTermsLink: <Link href={additionalTermsLink || '#'} {...LINK_PROPS} />,
        }),
        termsLink: <Link href={termsUrl || '#'} {...LINK_PROPS} />,
        privacyLink: <Link href={privacyUrl || '#'} {...LINK_PROPS} />,
      }}
    />
  </Typography>
);
